<main class="p-6 pb-10 ml-[52px] h-[calc(100vh_-_70px)] overflow-hidden">
    <div class="mb-6 flex justify-between items-center">
        <h1 class="text-shs-white-1 text-3xl font-bold flex items-center gap-1 font-sh-bree">Report</h1>
    </div>
    <div class="flex gap-4">
        <div class="bg-shs-gray-5 rounded-md p-6 max-w-[400px] w-full flex flex-col justify-between">
            <div class="flex flex-col gap-2">
                <h2 class="text-base text-font-primary font-bold">Request Report</h2>
                <p class="text-xs text-font-secondary mb-8">
                    To request a report of all currently available and closed CODs click the button below. You will
                    receive an email with a link to download the report once it is ready.
                </p>
            </div>
            <sag-ui-input label="E-Mail" placeholder="john.doe@siemens.com" [formControl]="emailControl"></sag-ui-input>
            <div class="flex justify-end mt-2">
                <sag-ui-button size="sm" [loading]="requesting()" (click)="requestReport()"
                    >Request report</sag-ui-button
                >
            </div>
        </div>
        <div class="bg-shs-gray-5 rounded-md p-6 max-w-[400px] w-full">
            <div class="flex flex-col gap-2 mb-4">
                <h2 class="text-base text-font-primary font-bold">Recent Reports</h2>
                <p class="text-xs text-font-secondary">View and download the most recent reports below.</p>
            </div>
            @if (reports() && reports().length > 0) { @for (item of reports(); track $index) {
            <div
                class="grid grid-cols-[32px_auto] my-2 p-2 items-center w-full hover:bg-shs-gray-4 rounded-md cursor-pointer"
                (click)="downloadReport(item)"
            >
                <span class="icon-download text-shs-orange text-sm"></span>
                <span class="text-sm text-font-primary truncate max-w-2/3">{{ item }}</span>
            </div>
            } } @else {
            <div class="flex justify-center h-full text-shs-white-1 text-xs mt-10">No recent reports</div>
            }
        </div>
        <div class="border border-shs-gray-4 rounded-md p-6 max-w-[400px] w-full flex flex-col justify-between">
            <div class="flex flex-col gap-2">
                <h2 class="text-base text-font-primary font-bold">Legacy Report</h2>
                <p class="text-xs text-font-secondary">
                    If you want to access reports from the legacy system you can download them here.
                </p>
            </div>
            <div class="flex justify-end mt-2">
                <sag-ui-button size="sm" icon="download" [loading]="downloading()" (click)="downloadLegacyReport()"
                    >Download</sag-ui-button
                >
            </div>
        </div>
    </div>
</main>
